const state =
    {
        isAddToBasketDisabled: false
    };

const mutations =
    {
        setAddToBasketDisabled(state, value)
        {
            state.isAddToBasketDisabled = value;
        }
    }

export default
{
    state,
    mutations
};
